export default (url = '') => {
  return url.startsWith('https://') ? '_blank' : '_self';
};
